import { useEffect, useState } from "react";

const Resize = () => {
    const [resize, setSize] = useState(); // default width, detect on server.

    useEffect(() => {
        window.addEventListener('orientationchange', () => {
            // console.log("The orientation of the screen is: " + );
            setSize(window.screen.orientation.angle)
        });
        // return () => window.removeEventListener('orientationchange', () => {
        //     setSize()
        // });
    }, [resize]);
    return resize
};


export default Resize;